import { useState } from 'react';
import { DEFAULT_WORKS_LIMIT } from 'utils/constants';
import { getLimitedList } from 'utils/helper';

export default ({ works, initialWorksList }) => {
  const [filteredWorks, setFilteredWorks] = useState(works);
  const [worksDisplay, setWorksDisplay] = useState(initialWorksList);
  const [tag, setTag] = useState(null);

  const hasHiddenItems = worksDisplay.length !== filteredWorks.length;

  const handleTagChange = (value) => {
    if (value === tag) {
      setTag(null);
      setWorksDisplay(initialWorksList);
    } else {
      setTag(value);

      const newFilteredWorks = (works || []).filter((work) => {
        const matches = (work?.tags || []).map((obj) => obj.slug);

        if (matches.includes(value)) {
          return work;
        }

        return false;
      });
      setFilteredWorks(newFilteredWorks);
      const newWorksDisplay = newFilteredWorks.slice(0, DEFAULT_WORKS_LIMIT);
      setWorksDisplay(newWorksDisplay);
    }
  };

  function handleMoreClick() {
    const newWorksDisplay = getLimitedList(filteredWorks, { limit: worksDisplay.length + DEFAULT_WORKS_LIMIT });
    setWorksDisplay(newWorksDisplay);
  }

  return {
    hasHiddenItems,
    works: worksDisplay,
    handleTagChange,
    handleMoreClick,
    tag,
  };
};
